/* Variation Lista Semplice of Listing block */
import React from 'react';
import PropTypes from 'prop-types';
import { ConditionalLink } from '@plone/volto/components';
import { Container, Row, Col } from 'design-react-kit';
import { ListingLinkMore } from 'design-comuni-plone-theme/components/ItaliaTheme';
import { RichTextRender } from 'design-comuni-plone-theme/components/ItaliaTheme/View';

const SimpleListTemplateCosaServe = ({
  items,
  title,
  isEditMode,
  linkTitle,
  linkHref,
  show_block_bg,
  show_pointer_list,
}) => {
  const servicesItems = items.filter((item) => item['@type'] === 'Servizio');

  return (
    <div className="simple-list-template-cosa-serve">
      <Container className="px-4">
        {title && (
          <Row>
            <Col>
              <h2 className="mb-4">{title}</h2>
            </Col>
          </Row>
        )}
        {servicesItems.length > 0 && (
          <Row>
            <Col>
              <table>
                <thead>
                  <tr>
                    <th>Servizio</th>
                    <th>Cosa serve</th>
                    <th>Uffici responsabili</th>
                  </tr>
                </thead>
                <tbody>
                  {servicesItems.map((item, index) => {
                    let ufficio_responsabile =
                      item.ufficio_responsabile?.length > 0
                        ? item.ufficio_responsabile
                        : null;
                    return (
                      <tr
                        key={index}
                        className={
                          index % 2 === 0
                            ? 'even rowservizio'
                            : 'odd rowservizio'
                        }
                      >
                        <td>
                          <ConditionalLink condition={!isEditMode} item={item}>
                            {item.title}
                          </ConditionalLink>
                        </td>
                        <td>
                          {item.cosa_serve &&
                            RichTextRender({
                              content: item.cosa_serve,
                              serif: false,
                            })}
                        </td>
                        <td>
                          {ufficio_responsabile?.map((ufficio, index) => {
                            return (
                              <React.Fragment key={`ufficio-${index}`}>
                                <ConditionalLink
                                  condition={!isEditMode}
                                  item={ufficio}
                                >
                                  {ufficio.title}
                                </ConditionalLink>
                                <br />
                              </React.Fragment>
                            );
                          })}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </Col>
          </Row>
        )}
        <ListingLinkMore title={linkTitle} href={linkHref} className="my-4" />
      </Container>
    </div>
  );
};

SimpleListTemplateCosaServe.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  linkTitle: PropTypes.any,
  linkHref: PropTypes.any,
  isEditMode: PropTypes.bool,
  title: PropTypes.string,
};

export default SimpleListTemplateCosaServe;
